import { Links } from './links';
import { User } from './user';
import { Brand } from './brand';
import { Size } from './size';
import { Color } from './color';
import { Category } from './category';
import { Followable } from './followable';


export class ProductImage {
  filename: string;
  filetype: string;
  value: string;
}


/**
 * The product comprises the main class of the domain. You can buy,
 * sell and create products. The product model implements some
 * important methods that are used in different places, so as to not
 * repeat ourselves in the components.  Note that we rely on the
 * server side to determine what a client side user can and can not
 * do, by the principle of HATEOAS.
 */
export class Product extends Followable {

  id: number;
  reference: string;
  _vendor: User;
  _name: string;
  _brand: Brand;
  _category: Category;
  description: string;
  state: number;
  size: number;
  _size: Size;
  color: number;
  _color: Color;
  custom_size: string;
  price: number;
  category: number;
  price_sale: number;
  ttl: number;
  images: Array<any> = [];
  frontimage: ProductImage;
  backimage: ProductImage;
  detailimage: ProductImage;
  thumb: ProductImage;
  _links: Links;
  _wfstate: string;
  wfstate: number;

  permissions: Array<string>;

  public isForSale(): boolean {

    try {
      return this._links.add_to_cart != null;
    } catch(e) {
      return false;
    }
  }

  public isInCart(): boolean {

    try {
      return this._links.rm_from_cart != null;
    } catch(e) {
      return false;
    }
  }

  public canHitSee(): boolean {
    try {
      return this._links.see != null;
    } catch(e) {
      return false;
    }
  }

  public canRevive(): boolean {
    try {
      return this._links.revive != null;
    } catch(e) {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Models/product.ts